import { render } from "./UpgradeGame.vue?vue&type=template&id=abafcd48"
import script from "./UpgradeGame.vue?vue&type=script&lang=js"
export * from "./UpgradeGame.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__